import { Box, BoxProps } from "@chakra-ui/react";
import MainLayoutContainer from "components/MainLayoutContainer/MainLayoutContainer";

interface LayoutProps {
  path?: any;
  location?: any;
  _sidebar?: BoxProps;
  _main?: BoxProps;
  children: any;
}

export default function Layout(props: LayoutProps) {
  const { children, _main } = props;
  // const [is1024px] = useMediaQuery("(max-width: 1024px)");

  return (
    <Box>
      <Box pos="relative">
        <MainLayoutContainer maxW="580px" m="0 auto" pos="relative" {..._main}>
          {children}
        </MainLayoutContainer>
      </Box>
    </Box>
  );
}
